import { firstHalfString } from "../../../utility/fp";

export const SignedDocumentTypes = {
  Promoter_View: 'Promoter_View',
  Promoter_Agreement: 'Promoter_Agreement'
};

export const documentDate = (document) => {
  const { created, last_modified } = document;

  if (last_modified == "0000-00-00 00:00:00") {
    return firstHalfString(created);
  } else {
    return firstHalfString(last_modified);
  }
};